import { ToolPageShell } from '@/shared/seo'
import { RedactPdfForm } from './RedactPdfForm'

export function ZamazatTekstVPdfPage() {
  return (
    <ToolPageShell utilityKey="redact-pdf">
      <RedactPdfForm />
    </ToolPageShell>
  )
}
